import React from 'react';
import classname from '@search/classname/src';
import { OfferYMapPlacemarkTooltipProps, YMapPlacemarkTooltip } from '@search/ymap/src/Placemark';
const cn = classname.bind(null, 'OfferYMapPlacemarkTooltip');

import './Placemark.css';

interface IOfferYMapPlacemarkTooltipProps extends OfferYMapPlacemarkTooltipProps {
    isHighlighted?: boolean;
}

export function OfferYMapPlacemarkTooltip({ isHighlighted, ...props }: IOfferYMapPlacemarkTooltipProps) {
    return (
        <YMapPlacemarkTooltip
            {...props}
            isClassifiedMap
            classes={
                isHighlighted ? {
                    active: cn('active'),
                    text: cn('text'),
                    total: cn('total'),
                    visited: cn('visited'),
                    link: cn('link')
                } : {
                    // wait back supports nb
                    link: props.theme ? cn('link-' + props.theme) : undefined,
                    visited: cn('visited'),
                    total: props.theme ? cn('total-' + props.theme) : undefined
                }
            }
        />
    );
}
